import React, { Component } from "react";
import Header from "../../components/admin/common/Header";
import Footer from "../../components/common/Footer";
import { Formik } from "formik";
import { toast } from "react-toastify";
import { setLoading } from "../../store/reducers/global-reducer";
import { connect } from "react-redux";
import store from "../../store/index";
import axios from "axios";
import nicon from "./../../assets/images/nicon.png";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import CryptoJS from "crypto-js";
import Modal from "react-bootstrap/Modal";
import { Helmet } from "react-helmet";
import noImg from "./../../assets/images/noimage.png";
import ModalBody from "react-bootstrap/esm/ModalBody";
import arrow_back from "../../assets/icons/arrow-back.svg"
import { enUS } from 'date-fns/locale';


class ManageBannerList extends Component {
  constructor(props) {
    super(props);
    this.cloudName = process.env.REACT_APP_CLOUD_NAME
    this.apiKey = process.env.REACT_APP_CLOUD_API_KEY
    this.apiSecret = process.env.REACT_APP_CLOUD_API_SECRET
    this.authInfo = store.getState().auth.authInfo;

    this.itemsPerPage = 6;
    this.state = {
      selectedRows: [],
      banner: [],
      show: false,
      showModal: false,
      selectedRowData: null,
      loading: true,
      error: null,

      dateRange: {
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      },
      filteredBanner: [],
      permissions: {
        add: false,
        edit: false,
        delete: false
      }
    };
  }

  componentDidMount() {
    this.getAdvertiesmentPermission();
    this.getBanner();
  }

  getAdvertiesmentPermission = async () => {
    const admin_Id = this.authInfo.id;
    try {
      const res = await axios.get(`admin/getAdvertiesmentPermission/${admin_Id}`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': `Bearer ${this.authInfo.token}`
        }
      })

      if (res.data.status === true && res.data.data) {
        this.setState({ permissions: res.data.data }, () => {
          console.log("Checking Response permission", this.state.permissions);
        });
      }

    } catch (error) {
      toast.error(error.response.data.message);
      console.error("Error fetching data: ", error);
    }
  }

  handleClose = () => {
    this.setState({ selectedRowData: false });
  };

  handlePreview = (row) => {
   
    this.setState({ selectedRowData: row });
    this.setState({ showModal: true });
  };

  getBanner = () => {
    axios
      .get("/admin/banner-list", {
        headers: {
          Authorization: `Bearer ${this.authInfo.token}`,
        },
      })
      .then((response) => {
        this.setState({
          banner: response.data.data,
          loading: false,
          error: null,
        });
      })
      .catch((error) => {
        this.setState({
          banner: [],
          loading: false,
          error: error,
        });
      });
  };

  handleRowSelected = (state) => {

    this.setState({ selectedRows: state.selectedRows });
  };

  handleDeleteSeletedData = async (id) => {
    // const { timestamp, signature } = this.createSignature();
    const imgDelUrl = `https://api.cloudinary.com/v1_1/${this.cloudName}/image/destroy`;
    const vidDelUrl = `https://api.cloudinary.com/v1_1/${this.cloudName}/video/destroy`;
    const { selectedRows } = this.state;
    const cloudPublicId = selectedRows.map((item) =>
      item.imageId === "" ? item.videoId : item.imageId
    );
  

    if (selectedRows.length === 0) {
      toast.error("Please select row....", { autoClose: 3000 });
    } else {
      try {
        const timestamp = Math.round(new Date().getTime() / 1000);
        const signature = CryptoJS.SHA1(
          `public_id=${cloudPublicId}&timestamp=${timestamp}${this.apiSecret}`
        ).toString(CryptoJS.enc.Hex);
        const cloudinaryUrl = selectedRows.map((item) =>
          item.imageId === "" ? vidDelUrl : imgDelUrl
        );
        const response = await axios.delete(cloudinaryUrl, {
          params: {
            public_id: cloudPublicId,
            api_key: this.apiKey,
            signature: signature,
            timestamp: timestamp,
          },
        });
        if (response.status === 200) {
          console.log("Image deleted successfully");
        } else {
          console.log("Failed to delete image");
        }
      } catch (error) {
        console.log("Error deleting image", error);
      }

      for (let i = 0; i < selectedRows.length; i++) {
        const ids = selectedRows[i].id;
        
        axios
          .delete(`/admin/banner/${ids}`, {
            headers: {
              Authorization: `Bearer ${this.authInfo.token}`,
            },
          })
          .then((res) => {
            this.getBanner();
          })
          .catch((error) => {
            console.log("error", error);
          });
      }
      this.setState({ loading: true });
    }
  };

  handleEdit = (id) => {
    this.props.history.push(`/admin/edit-advertisement/${id}`);
  };

  handleStatusUpdate = (id) => {
    {
      id.status === "Unpublish"
        ? axios
          .put(
            "/admin/updateBanner/" + id.id,
            { status: "Publish" },
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: `Bearer ${this.authInfo.token}`,
              },
            }
          )
          .then((response) => {
            if (response) {
              this.getBanner();
            }
          })
          .catch((error) => {
            console.log("error", error);
          })
        : axios
          .put(
            "/admin/updateBanner/" + id.id,
            { status: "Unpublish" },
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: `Bearer ${this.authInfo.token}`,
              },
            }
          )
          .then((response) => {
            if (response) {
              this.getBanner();
            }
          })
          .catch((error) => {
            console.log("error", error);
          });
    }
  };

  banner_column = [
    {
      name: "Advertisement Image/Video",
      selector: (row, i) =>
        row.video === "" ? (
          <img
            src={row.image}
            alt="No Image/video select"
            style={{ width: "350px", height: "90px" }}
          />
        ) : (
          <video
            width="350"
            height="90"
            src={row.video}
            autoPlay
            loop
            alt="No Image/video select"
          />
        ),
      sortable: true,
      width: "350px",
    },
    {
      name: "Advertisement Name",
      selector: (row, i) => row.bannerName,
      sortable: true,
      // width: 'auto',
    },
    {
      name: "Category",
      selector: (row, i) => row.category,
      sortable: true,
      width: "auto",
    },
    {
      name: "Created Date",
      selector: (row, i) => new Date(row.createdAt).toLocaleString(),
      sortable: true,
    },
    {
      name: "Author Details",
      selector: (row, i) =>
        row.authorDetails === null ? (
          ""
        ) : (
          <>
            <p>{row.authorDetails.name}</p>
            <p>{row.authorDetails.email}</p>
            {/* <p>{row.authorDetails.role}</p> */}
          </>
        ),
      sortable: true,
      width: "auto",
    },
    {
      name: "Advertisement Status",
      selector: (row, i) =>
        row.status === "Unpublish" ? (
          <p className="p-1 fw-bold text-white bg-danger bg-opacity-4 border-info rounded">
            {row.status}
          </p>
        ) : (
          <p className="p-1 fw-bold text-white bg-success  bg-opacity-4 border-info rounded">
            {row.status}
          </p>
        ),
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <button
            type="submit"
            className="custom_btn btn_yellow_bordered w-auto btn btn-width action_btn_new"
            onClick={() =>
              this.handleStatusUpdate({ id: row.id, status: row.status })
            }
          >
            {row.status === "Unpublish" ? "Publish" : "Block"}
          </button>
          <button
            type="submit"
            className="custom_btn btn_yellow_bordered w-auto btn btn-width action_btn_new"
            onClick={() => this.handlePreview(row)}
          >
            Preview
          </button>
          <button
            onClick={() => this.handleEdit(row.id)}
            className="custom_btn btn_yellow_bordered w-auto btn btn-width action_btn_new"
            disabled={!this.state.permissions.edit}
          >
            Edit
          </button>
          <button
            className="custom_btn btn_yellow_bordered w-auto btn btn-width action_btn_new"
            onClick={() => this.handleDeleteSeletedData(row._id)}
            disabled={!this.state.permissions.delete}
          >
            Delete
          </button>
        </>
      ),
    },
  ];

  handleIframeClick = () => {
    window.open(this.state.selectedRowData.siteUrl);
  };

  handleDateRangeChange = (ranges) => {
    const { banner } = this.state;
    const filteredBanner = banner.filter((item) => {
      const itemDate = new Date(item.startDate);
      return (
        itemDate >= ranges.selection.startDate &&
        itemDate <= ranges.selection.endDate
      );
    });

    this.setState({
      dateRange: {
        startDate: ranges.selection.startDate,
        endDate: ranges.selection.endDate,
        key: "selection",
      },
      filteredBanner,
    });
  };

  render() {
    const { banner, selectedRows, dateRange, filteredBanner } = this.state;
    return (
      <React.Fragment>
        <Header />
        <div className="inr_top_page_title">
          <h2>Manage Advertisements</h2>
        </div>
        <Helmet>
          <title>{"Admin - Manage Advertisements - Pay Earth"}</title>
        </Helmet>
        <section className="inr_wrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="cart adv_banner_wrapper">
                  <div className="dash_inner_wrap">
                    <div
                      className="col-md-12 pt-2 pb-3 d-flex align-items-center"
                      style={{
                        flexWrap: "wrap",
                        justifyContent: "space-between",
                      }}
                    >
                      <div className="dash_title" style={{ flex: "1 1 auto" }}>
                        Manage Advertisements
                      </div>

                      <div
                        className="d-flex gap-2"
                        style={{
                          flexWrap: "wrap",
                          justifyContent: "flex-end",
                          flex: "1 1 auto",
                        }}
                      >
                        <Link
                          className={`btn custom_btn ${
                            this.state.permissions.add ? "btn_yellow" : "btn_disabled"
                          }`}
                          to={
                            this.state.permissions.add
                              ? "/admin/create-advertisement"
                              : "#"
                          }
                          onClick={(e) => {
                            if (!this.state.permissions.add) {
                              e.preventDefault();
                            }
                          }}
                          style={{
                            whiteSpace: "nowrap",
                            minWidth: "140px",
                            textAlign: "center",
                            flex: "1 1 auto",
                          }}
                        >
                          Create New Advertisement
                        </Link>

                        <button
                          type="button"
                          className="btn custum_back_btn btn_yellow d-flex align-items-center justify-content-center"
                          onClick={() => window.history.back()}
                          style={{
                            whiteSpace: "nowrap",
                            minWidth: "100px",
                            textAlign: "center",
                            flex: "1 1 auto",
                          }}
                        >
                          <img src={arrow_back} alt="back" style={{ height: "18px" }} />
                          <span className="ms-1">Back</span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="cart_list adv_banner_panel">
                    <div
                      className="tab-pane fade show active"
                      id="nav-draft-post"
                      role="tabpanel"
                      aria-labelledby="nav-draft-post-tab"
                    >
                      <div className="DT_ext_row adv-banner-row ">
                        <div className="date-wrapper col-md-3">
                          <DateRangePicker
                            locale={enUS}
                            ranges={[dateRange]}
                            onChange={this.handleDateRangeChange}
                          />
                        </div>
                        <div className="tablewrapper col-md-9">
                          <div className="cart_wrap">
                            <div className="items_incart">
                              <span className="text-uppercase">
                                (
                                {filteredBanner.length === 0
                                  ? banner.length
                                  : filteredBanner.length}
                                ) ADVERTISEMENT IN YOUR LIST
                              </span>
                            </div>
                          </div>
                          <DataTableExtensions
                            columns={this.banner_column}
                            data={
                              filteredBanner.length === 0 ? banner : filteredBanner
                            }
                          >
                            <DataTable
                              pagination
                              highlightOnHover
                              noHeader
                              defaultSortField="id"
                              defaultSortAsc={false}
                              selectableRows
                              selectedRows={selectedRows}
                              onSelectedRowsChange={this.handleRowSelected}
                              paginationPerPage={this.itemsPerPage}
                              paginationRowsPerPageOptions={[6, 10, 15, 20]}
                            />
                          </DataTableExtensions>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />

        <Modal
          show={this.state.showModal}
          onHide={() => this.setState({ showModal: false })}
          // dialogClassName="modal-90w"
          dialogClassName="modal-fullscreen"
          aria-labelledby="example-custom-modal-styling-title"
        >
          <Modal.Header closeButton>
            <Modal.Title>Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedRowData && (
              <div className="banner-container">
                <p>{this.state.selectedRowData.siteUrl}</p>
                <a href={this.state.selectedRowData.siteUrl} target="_blank">
                  <iframe
                    src={
                      !this.state.selectedRowData.image
                        ? this.state.selectedRowData.video
                        : this.state.selectedRowData.image
                    }
                    width="1100"
                    height="315"
                    allow="autoplay; encrypted-media"
                  ></iframe>
                </a>

                <button className="close-button" onClick={this.handleClose}>
                  Close
                </button>
              </div>
            )}
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}

export default ManageBannerList;
